import { apiConstants } from '../../config';

const fetchMaps = () => {
  
};

export { fetchMaps };